var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarM = function SvgDefaultAvatarM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9 55.3c3.5 0 5.8-.4 5.8-1.6 0-.9-1-1.2-3.3-1.3-.8-.2-.9-2-.9-4.5v-16c2.6 6 5.5 12.6 8.4 18.4.7 1.4 1.3 2.1 2.4 2.1 1 0 1.6-.8 2.3-2.1 2.7-5.5 5.1-11 8.1-18.3.1.9.1 2 .1 3.2V48c0 2.5-.2 4.4-.8 4.5-2.3.1-3.2.4-3.2 1.3 0 1.2 2.2 1.6 6.3 1.6 4 0 6.3-.4 6.3-1.6 0-.9-1-1.2-3-1.3-.5-.2-.7-1.5-.7-4.5V32.8c0-2.8.2-4.5.7-4.9 2-.1 3-.4 3-1.3 0-1.2-2.2-1.6-5.2-1.6-2.9 0-4.2.5-5 2.6-2.9 7-5.6 13.4-8.1 18.6-3.1-6.6-6-13.4-8.5-18.8-1-2.1-1.9-2.4-5-2.4-2.9 0-5 .4-5 1.6 0 .9.9 1.1 3 1.3.7.4.8 2.1.8 5.1v14.9c0 2.4-.2 4.3-.7 4.5-2.3.1-3.2.5-3.2 1.3 0 1.2 2.2 1.6 5.4 1.6z"
  })));
};
export default SvgDefaultAvatarM;